import LmtPage from './lmt'

export default LmtPage
